export type FacetOrderState = string[];

export function getFacetOrderInitialState(): FacetOrderState {
  return [];
}
